import { Star } from 'lucide-react';

export default function Marquee({ items, className = '', fast = false, testId = 'editorial-marquee' }) {
  return (
    <div data-testid={testId} className={`overflow-hidden py-5 ${className}`}>
      <div className={`${fast ? 'marquee-track-fast' : 'marquee-track'} flex w-max items-center`}>
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
            {items.map((t, i) => (
              <span
                key={i}
                className="flex items-center gap-8 whitespace-nowrap pr-8 font-display text-sm font-bold uppercase tracking-[0.35em]"
              >
                {t}
                <Star className="h-4 w-4 fill-current opacity-70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
